module.exports = __webpack_public_path__ + "img/explorer-reader.dd998590.png";